import React from 'react';
import classNames from 'classnames';
import { IIconProps, AddIcon } from 'components/icons';

interface RoundButtonProps {
	onClick?: () => void;
	text?: string;
	lg?: boolean;
	Icon?: React.FC<IIconProps>;
	size?: number;
	padding?: number;
	wrapperClass?: string;
}

export const RoundButton = ({
	onClick,
	text,
	Icon = AddIcon,
	lg,
	size,
	padding,
	wrapperClass,
}: RoundButtonProps) => {
	const style = size
		? {
				width: `${size}px`,
				height: `${size}px`,
				padding: `${padding}px`,
		  }
		: {};

	return (
		<button
			type="button"
			className={classNames('round-button', wrapperClass)}
			onClick={onClick}
		>
			<Icon
				iconClass={classNames('round-button__icon', {
					lg,
				})}
				style={style}
			/>
			{text && <p className="round-button__text">{text}</p>}
		</button>
	);
};
